
const pageConfig = {
    page: 0,
    pageSize: 10
};

export default {
    pageConfig
};
